// Puerto del dominio (repository abstracto) para iniciar un pago y consultar su estado.
import { Observable } from 'rxjs';
import {
  CheckPaymentStatusInput,
  CheckPaymentStatusResult,
  StartPaymentInput,
  StartPaymentResult,
} from '../../interfaces/payment/payment.interface';

export abstract class PaymentRepository {
  abstract startPayment(input: StartPaymentInput): Observable<StartPaymentResult>;
  abstract checkPaymentStatus(input: CheckPaymentStatusInput): Observable<CheckPaymentStatusResult>;
}
